import { ColumnMappingBaseTransformPlainObject } from './columnMappingBase.plainObject';
import { ColumnPlainObject } from './column.plainObject';

export class SinkPlainObject extends ColumnMappingBaseTransformPlainObject {
    public columns: ColumnPlainObject[] = [];
}
